export default "__VITE_ASSET__99a929b8__"